module.exports = __webpack_public_path__ + "img/crosslink-search-results-crop.67398404.png";